module.exports = __webpack_public_path__ + "static/media/sunicon.9140df09.png";